import { IconEmail, IconPhone } from "@assets/icons";
import "./index.scss";
import { useAppDispatch, useAppSelector } from "@hooks/redux";
import { useTiktokAuth } from "@hooks/useTiktokAuth";
import { usePopoverGoogleAuth } from "@hooks/usePopoverGoogleAuth";
import { useVerifyEmail } from "@hooks/useVerifyEmail";
import { useVerifyPhone } from "@hooks/useVerifyPhone";
import { updateUserInfo } from "@store/globalSlice";
import { isInIframe } from "@utils/window";
import classNames from "classnames";
import { useEffect, useMemo, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { WxVerfiedModal } from "@pages/me/AccountInformation/WxMemberModal";
// import { Tooltip } from "antd";
import { IconCredit } from "@assets/icons";
// import { IconHelp } from "@icons/common";
import { getProfile } from "@apis/http/api";
import { IconLineCheck } from "@kalodata/kds-design-icons";
import { ClipTag } from "@components/ClipTag/ClipTag";

interface Option {
  type: "phone" | "tiktok" | "email" | "wechat" | "google";
  icon: React.ReactNode;
  title: string;
  verifyStatus: boolean;
  verifyTag: string;
  verifyAction: string;
  verifyDesc: string;
}
const AccountInformation = () => {
  const { userInfo, membership } = useAppSelector((state) => state.globalReducer);
  const phoneVerified = !!userInfo?.phoneVerified;
  const tiktokVerified = !!userInfo?.tiktokVerified;
  const emailVerified = !!userInfo?.emailVerified;
  const googleVerified = !!userInfo?.googleVerified;

  const { totalRemain } = useAppSelector((state) => state.globalReducer.creditInfo);

  const dispatch = useAppDispatch();
  const { language: _language, isLogin } = useAppSelector((state) => state.globalReducer);
  const { setOpen: _setOpen, verifyPhoneModal } = useVerifyPhone({});

  const { setOpen: _setEmailOpen, verifyEmailModal } = useVerifyEmail({});
  // const { setWxMemberModalInfo, boundWxData, wxMemberModalInfo } = useHeaderTopLabel();
  const { t } = useTranslation();

  const wechatVerified = !!userInfo.wxVerified;

  const account_info = useMemo<Option[]>(() => {
    const level = membership?.level === "Trial" ? "Standard" : membership?.level;

    const info: Option[] = [
      {
        type: "phone",
        icon: <IconPhone width={24} height={24}></IconPhone>,
        title: userInfo.phoneNumber
          ? `+${userInfo.phoneCountryCode} ${userInfo.phoneNumber}`
          : userInfo.phoneNumber || t("Phone Number"),
        verifyStatus: phoneVerified,
        verifyDesc: `Get 1-day ${level?.toLocaleLowerCase()} membership`,
        verifyTag: phoneVerified ? "Verified" : "Unverified",
        verifyAction: "Verify",
      },
      {
        type: "email",
        title: userInfo.email || "Email",
        icon: <IconEmail width={24} height={24}></IconEmail>,
        verifyStatus: emailVerified,
        verifyDesc: `Get 1-day ${level?.toLocaleLowerCase()} membership`,
        verifyTag: emailVerified ? "Verified" : "Unverified",
        verifyAction: "Verify",
      },
    ];

    if (isLogin) {
      if (userInfo.bizCountry === "china") {
        // info.push({
        //   type: "wechat",
        //   title: t("WeChat"),
        //   icon: <IconWechat width={24} height={24}></IconWechat>,
        //   verifyStatus: wechatVerified,
        //   verifyDesc: `Get 1-day ${boundWxData && boundWxData.topLabelModalButtonText ? boundWxData?.topLabelModalButtonText.toLowerCase() : ""} membership`,
        //   verifyTag: wechatVerified ? "Verified" : "Unverified",
        //   verifyAction: "Verify",
        // });
      } else {
        info.push(
          // {
          //   type: "tiktok",
          //   title: userInfo.tiktokUserHandle ? `@${userInfo.tiktokUserHandle}` : "TikTok",
          //   icon: <IconTiktok width={24} height={24}></IconTiktok>,
          //   verifyStatus: tiktokVerified,
          //   verifyDesc: `Get 1-day ${level?.toLocaleLowerCase()} membership`,
          //   verifyTag: tiktokVerified ? "Verified" : "Unverified",
          //   verifyAction: "Verify",
          // },
          // {
          //   type: "google",
          //   title: userInfo.googleName ? userInfo.googleName : "Google",
          //   icon: <IconGoogle width={24} height={24}></IconGoogle>,
          //   verifyStatus: googleVerified,
          //   verifyDesc: "",
          //   verifyTag: googleVerified ? "Verified" : "Unverified",
          //   verifyAction: "Verify",
          // },
        );
      }
    }

    if (isInIframe()) {
      return info.slice(0, 1);
    }

    return info;
  }, [
    userInfo,
    phoneVerified,
    emailVerified,
    tiktokVerified,
    googleVerified,
    wechatVerified,
    isLogin,
    membership?.level,
    t,
    // boundWxData?.topLabelModalButtonText,
  ]);

  const { tiktokLink: _tiktokLink, SpinDom } = useTiktokAuth("authorize", undefined, undefined, async () => {
    await getProfile().then((res) => {
      dispatch(updateUserInfo(res));
      // dispatch(queryMembership({ country: region }));
    });
  });

  const { googlePopoverLink: _googlePopoverLink, SpinDom: GoogleSpinDom } = usePopoverGoogleAuth(
    "authorize",
    undefined,
    undefined,
    async () => {
      await getProfile().then((res) => {
        dispatch(updateUserInfo(res));
        // dispatch(queryMembership({ country: region }));
      });
    },
  );

  const [_account_info, setAccountInfo] = useState<Option[]>(account_info);
  const [verfiedModal, setVerfiedModal] = useState(false);

  // 同步 account_info 的变化到 _account_info
  useEffect(() => {
    setAccountInfo(account_info);
  }, [account_info]);

  return (
    <div className="flex flex-col py-[32px] border-b border-kds-border">
      <div className="text-[16px] font-medium mb-[16px]">
        <Trans>Subscription</Trans>
      </div>
      <div className="text-[16px] font-medium mb-[16px]">
        <div className="text-kds-fg-soft text-[14px] flex justify-between items-center gap-[40px] mb-[24px]">
          <div className="w-[120px]">
            <Trans>Plan</Trans>
          </div>
          {/* <div className="flex-1">{membership?.level}</div> */}
          <div className="flex-1">
            <Trans>Free</Trans>
          </div>
          {/* <CommonButton type="primary-gradient" border={false} className="min-w-[82px]">
            <Trans>Update</Trans>
          </CommonButton> */}
        </div>
        <div className="text-kds-fg-soft text-[14px] flex justify-between gap-[40px] items-start">
          <div className="w-[120px]">
            <Trans>Credits</Trans>
          </div>
          <div className="flex-1">
            <div className="flex flex-row items-center gap-[4px]">
              <IconCredit></IconCredit>
              <div className="text-kds-fg">{totalRemain}</div>
              {/* <Tooltip
                overlayInnerStyle={{ maxWidth: "none", width: "max-content" }}
                title={
                  <div className="whitespace-nowrap">
                    <div className="flex items-center gap-[4px]">
                      <Trans>Plan Credits</Trans>:<IconCredit className="w-[16px] h-[16px] shrink-0" />
                      <span>{monthlyRemain}</span>
                    </div>
                    <div className="flex items-center gap-[4px]">
                      <Trans>Top-up Credits</Trans>:<IconCredit className="w-[16px] h-[16px] shrink-0" />
                      <span>{permanentRemain}</span>
                    </div>
                    {subAccount && (
                      <div className="flex items-center gap-[4px]">
                        <Trans>Kalodata Main Account Credits</Trans>:
                        <IconCredit className="w-[16px] h-[16px] shrink-0" />
                        <span>{mainTotalRemain}</span>
                      </div>
                    )}
                  </div>
                }
              >
                <span>
                  <IconHelp className="w-[16px] h-[16px]" />
                </span>
              </Tooltip> */}
            </div>
          </div>
        </div>
      </div>
      {/* {(userInfo.email || userInfo.phoneNumber) && (
        <>
          <ResetPassword></ResetPassword>
        </>
      )} */}
      <div>
        <div className="inline-flex flex-col gap-[16px] pt-[16px] border-t border-kds-border">
          {_account_info.map((account) => {
            let verifyStatus = account.verifyStatus;
            if (!verifyStatus) return;
            return (
              <div className="flex flex-row items-center" key={account.type}>
                <div className={twMerge("flex flex-row items-center gap-[4px]", !verifyStatus ? "w-[254px]" : "")}>
                  <div className="flex flex-row items-center gap-[4px] h-[28px]">
                    {account.icon}
                    <div
                      className={classNames("min-w-[120px]", {
                        "text-kds-fg!": verifyStatus,
                      })}
                    >
                      {account.title}
                    </div>
                  </div>
                  <div className="flex flex-row items-center justify-end">
                    {verifyStatus && (
                      <ClipTag
                        label={account.verifyTag}
                        icon={<IconLineCheck size={16} className="text-kds-accent-fg" />}
                      />
                    )}
                  </div>
                </div>
                {/* <div className="flex flex-row items-center h-[28px] gap-[8px]">
                  {!verifyStatus && (
                    <div className="flex flex-row items-center gap-[8px]">
                      <CommonButton
                        className="min-w-[78px]"
                        onClick={() => {
                          verityFn(account.type);
                        }}
                        type="filled"
                      >
                        <Trans>{account.verifyAction}</Trans>
                      </CommonButton>
                    </div>
                  )}
                </div> */}
              </div>
            );
          })}
        </div>
      </div>
      {verfiedModal && <WxVerfiedModal verfiedModal={verfiedModal} setVerfiedModal={setVerfiedModal}></WxVerfiedModal>}
      {verifyPhoneModal()}
      {verifyEmailModal()}
      {SpinDom()}
      {GoogleSpinDom()}
      {/* {!!showWxMemberModal && userInfo.bizCountry === "china" && userInfo.wxVerified === 0 && (
        <WxMemberModal
          open={showWxMemberModal}
          modalInfo={wxMemberModalInfo}
          onClose={(bindSuccess: boolean) => {
            setShowWxMemberModal(false);
            setWxMemberModalInfo({
              bgUrl: "",
              days: "",
              membersText: "",
            });
            if (bindSuccess) {
              setAccountInfo((account) => {
                return account.map((item) => {
                  if (item.type === "wechat") {
                    item.verifyStatus = true;
                    item.verifyTag = "Verified";
                  }
                  return item;
                });
              });
              if (!userInfo.subAccount) {
                setVerfiedModal(true);
              } else {
                message.success(t("Verified successfully"));
              }
            }
          }}
        />
      )} */}
    </div>
  );
};

export default AccountInformation;
